import DIApi from './_diApi';

/**
 * Config API ngân hàng thương mại
 */
class CommercialBankAPI extends DIApi {
  controllerName = 'CommercialBanks';
}

export default new CommercialBankAPI();
